import { Component } from '@angular/core';
import { VersionCheckService } from './services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Kundenzufriedenheit';

  constructor(private versionCheck: VersionCheckService) { }

  ngOnInit() {
    this.versionCheck.initVersionCheck();
    if (location.pathname.includes('/en/')) document.title = "Customer Survey";
    if (location.pathname == "/") location.href = "https://www.google.at";
  }
}
